import {GameModel} from "@nolimitcity/slot-game/bin/model/GameModel";
import {ISymbolValues, ITheRaveGameData, ITheRaveInitData} from "./data/ITheRaveData";
import {ApiPlugin} from "@nolimitcity/slot-launcher/bin/plugins/ApiPlugin";
import {TheRaveParsedInitData} from "./data/TheRaveParsedInitData";
import {TheRaveParsedGameData} from "./data/TheRaveParsedGameData";
import {TheRaveDataParser} from "./data/TheRaveDataParser";
import {TheRaveParsedData} from "./data/TheRaveParsedData";
import {APIBetEventData, APIFeatureBetEventData} from "@nolimitcity/slot-launcher/bin/interfaces/APIBetEventData";
import {APIBetType} from "@nolimitcity/slot-launcher/bin/interfaces/APIBetType";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {TheRave} from "../TheRave";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";

export class TheRaveModel extends GameModel<ITheRaveInitData, ITheRaveGameData> {

    public parsedInitData:TheRaveParsedInitData;
    public parsedGameData:TheRaveParsedGameData;
    public currentParsedData:TheRaveParsedData;
    public reels:string[][];
    public reelSizes:number[];
    public isRestore:boolean = false;
    public totalWays:number;
    public freespinMidMultipliers:number[];
    public freespinTriggeredThisSpin:boolean;
    public nextMode:string;
    public isFreespin:boolean;
    public startNearWinAtScatterCount:number;
    public scatterPositions:number[];
    public symbolValues:ISymbolValues;
    private _parser:TheRaveDataParser;
    public nextPlayerInteraction:any;
    public isRestoreFeatureBet : boolean;
    public buyFeatureName : string;
    public doDoubleXways : boolean [];
    private _isFreeBetFeatureBet:boolean = false;
    constructor(api:ApiPlugin, triggerEvents:boolean = true) {
        super(api, triggerEvents);
        api.events.on(APIEvent.BET, (data:APIBetEventData) => this.onBet(data));
        this._parser = new TheRaveDataParser();

        api.events.once("featureBet", (data : boolean)=>{
            this.isRestoreFeatureBet = data;
        });
        api.events.once("featureName", (data : string)=>{
            this.buyFeatureName = data;
        });
        TheRave.apiPlugin.events.on(APIEvent.BET, (betData: APIFeatureBetEventData) => {
            for (let index = 0; index < TheRave.model.initData.featureBuyTimesBetValue.length; index++) {
                if (TheRave.model.initData.featureBuyTimesBetValue[index].name === betData.featureName) {
                    this.buyFeatureName = betData.featureName;
                    Logger.logDev("Opted Feature : ", this.buyFeatureName);
                    break;
                }
            }
        });
        TheRave.apiPlugin.events.on(APIEvent.ACTION_SPINS_BET, (betData: APIFeatureBetEventData) => {
            for (let index = 0; index < TheRave.model.initData.featureBuyTimesBetValue.length; index++) {
                if (TheRave.model.initData.featureBuyTimesBetValue[index].name === betData.featureName) {
                    this.buyFeatureName = betData.featureName;
                    Logger.logDev("Opted Feature : ", this.buyFeatureName);
                    break;
                }
            }
        });
    }

    protected onInit(data:ITheRaveInitData):void {
        this.parsedInitData = new TheRaveParsedInitData(data, this._parser);
        this.currentParsedData = this.parsedInitData;
        this.isRestore = data.isRestoreState;
        this.symbolValues = data.symbolValues;
        this.isFreespin = this.isRestore;
        this.freespinTriggeredThisSpin = data.freespinTriggeredThisSpin;
        this.nextMode = data.nextMode;
        this.freespinMidMultipliers = this.parsedInitData.freespinMidMultipliers;
        this.totalWays = this.parsedInitData.totalWays;
        this.reels = this.parsedInitData.reels;
        this.reelSizes =  this.parsedInitData.reelSizes;
        this.scatterPositions = this.parsedInitData.scatterPositions;
        this.startNearWinAtScatterCount = 2;
        this.nextPlayerInteraction = data.nextPlayerInteraction;
        this.doDoubleXways = data.doDoubleXways;
        Logger.logDev("NEXT PLAYER INTERACTION", this.nextPlayerInteraction);
        super.onInit(data);
    }

    protected onGame(data:ITheRaveGameData):void {
        this.parsedGameData = new TheRaveParsedGameData(data, this._parser);
        this.currentParsedData = this.parsedGameData;
        this.isRestore = false;
        this.nextMode = data.nextMode;
        this.totalWays = data.totalWays;
        this.isFreespin = this.parsedGameData.isFreespin;
        this.freespinMidMultipliers = this.parsedGameData.freespinMidMultipliers;
        this.reels = this.parsedGameData.reels;
        this.reelSizes =  this.parsedGameData.reelSizes;
        this.freespinTriggeredThisSpin = this.parsedGameData.freespinTriggeredThisSpin;
        this.scatterPositions = this.parsedGameData.scatterPositions;
        this.doDoubleXways = data.doDoubleXways;
        super.onGame(data);
    }

    private onBet(data:APIBetEventData) {
        if (data.type == APIBetType.FEATURE_BET && data.playerInteraction.featureName !== "BOOSTED_BET") {
            this.startNearWinAtScatterCount = 2;
        }
        if(data.type == APIBetType.NORMAL_BET) {
            this.startNearWinAtScatterCount = 2;
            return;
        }

        if(data.type == APIBetType.FEATURE_BET){
            if(data.playerInteraction.featureName === "BOOSTED_BET") {
                this.startNearWinAtScatterCount = 2;
            }else if(data.playerInteraction.featureName === "LUCKY_DRAW") {
                this.startNearWinAtScatterCount = 3;
            }else{
                this.startNearWinAtScatterCount = 6;
            }
        }
    }

    public set isFreeBetFeatureBet(value:boolean){
        this._isFreeBetFeatureBet = value;
    }
}